import { createSlice } from "@reduxjs/toolkit";

const FormSchema = createSlice({
  name: "FormSchema",
  initialState: "",
  reducers: {
    saveFormSchema: (state, action) => action.payload,
  },
});

export default FormSchema;
